import { Column } from './Column/Column'
import { Columns } from './MultiColumn.models'
import { Container, ContainerWrapper, StyledColumn } from './MultiColumn.style'

export const MultiColumn = ({ columns, backgorundColor }: Columns) => {

    return (
        <ContainerWrapper>
             <Container backgroundColor={backgorundColor}>
                {columns && columns.length > 0 &&
                    columns.map((column, index) => {
                        return (
                            <StyledColumn key={index} colCount={columns.length} backgroundColor={backgorundColor}>
                                <Column {...column} />
                            </StyledColumn>
                        );
                    })}
            </Container>
        </ContainerWrapper>
    );
}
